// @core/api/endpoints/team/add_team_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddTeamMemberRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Add team member
 * Directly adds a user as a team member without the invitation flow. Requires admin privileges on the team.
 */
export async function AddTeamMember(
  team_id: string,
  data: AddTeamMemberRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/members`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
